import { managementCompany } from './settlementCareData';
import styles from './SettlementCare.module.scss';

export function SettlementCare() {
  return (
    <section className={styles.section} id="management" aria-labelledby="care-title">
      <div className={styles.inner}>
        <header className={styles.header} data-reveal>
          <p className={styles.eyebrow}>{managementCompany.legalName}</p>
          <h2 id="care-title">Посёлок под профессиональным управлением</h2>
        </header>

        <div className={styles.copy} data-reveal data-reveal-delay="1">
          <p>
            Обслуживанием Лучезарной Долины занимается профессиональная управляющая компания{' '}
            {managementCompany.legalName}.
          </p>
          <p>
            У жителей есть единая организация, ответственная за общую территорию и внутрипоселковую
            инфраструктуру. Это позволяет решать текущие вопросы системно и поддерживать посёлок в
            порядке по мере его развития.
          </p>
        </div>

        <div className={styles.boundary} data-reveal>
          <div>
            <span>01 · Системная работа</span>
            <p>Обслуживание общей территории и внутрипоселковой инфраструктуры.</p>
          </div>
          <div>
            <span>02 · Понятное взаимодействие</span>
            <p>
              Информация, начисления, документы и заявки в мобильном приложении. 
              А также официальные каналы связи и чат жителей.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
